<div
    class="agpr-sortOrder-splitButton-container"
    (clickOutside)="sortOrderDropdownDisplay = false"
    [attachOutsideOnClick]="true"
>
    <div class="agpr-sortOrder-splitButton">
        <button
            pButton
            [id]="id + '_sortOrder_splitButtonOrder'"
            class="agpr-sortOrder-splitButtonOrder"
            [class.agpr-sortOrder-splitButtonOrder--withDropdown]="hasDropdown"
            [icon]="sortOrderIcon"
            (click)="toggleSortOrder()"
            [disabled]="isDisabled"
            [agprTooltip]="tooltip | localize"
            tooltipPosition="top"
            [useTooltipAsAriaLabel]="!!tooltip"
            [attr.aria-label]="'Discover.accessibility.sortOrder.reverseButton' | localize: { sortOrder: sortOrder }"
        ></button>
        @if (hasDropdown) {
            <button
                #trigger
                pButton
                class="agpr-sortOrder-splitButtonDropdown agpr-expandToggle"
                [id]="id + '_sortOrder_splitButtonDropdown'"
                icon="fa-solid fa-angle-down"
                [disabled]="isDisabled"
                [attr.aria-label]="'Discover.accessibility.sortOrder.sortOrderDropdown' | localize"
                [attr.aria-expanded]="sortOrderDropdownDisplay"
                [attr.aria-controls]="id + '_sortOrder_listbox'"
                [agprTooltip]="'Discover.accessibility.sortOrder.sortOrderDropdown' | localize"
                tooltipPosition="top"
                (keydown)="onTriggerKeydown($event)"
                (click)="sortOrderDropdownClick()"
            ></button>
        }
    </div>
    @if (sortOrderDropdownDisplay) {
        <ul
            #listbox
            role="listbox"
            [id]="id + '_sortOrder_listbox'"
            class="agpr-sortOrder-dropdownPanelItems"
            agprListKeyboardNavigation
        >
            @for (item of sortByOptions; track item; let i = $index) {
                <li
                    role="option"
                    [id]="id + '_sortOrder_dropdownItems_' + i"
                    class="agpr-sortOrder-dropdownPanelItem"
                    [ngClass]="{
                        'agpr-sortOrder-dropdownPanelItem--selected': (item[optionKey] === selectedSortField[optionKey])
                    }"
                    [attr.aria-selected]="item[optionKey] === selectedSortField[optionKey]"
                    tabindex="-1"
                    (keydown)="onOptionKeydown($event, i)"
                    (click)="selectSortField(item)"
                >
                    <span>{{ item[optionLabel] | localize }}</span>
                </li>
            }
        </ul>
    }
</div>
